module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings-permissions/settings-permissions.component.scss
// module id = ./src/app/pages/settings-permissions/settings-permissions.component.scss
// module chunks = main